export const LANG_CHANGE = 'LANG_CHANGE';
export const ANIMATION_STATE_CHANGE = 'ANIMATION_STATE_CHANGE';